import { render, staticRenderFns } from "./SpanLayoutConfig.vue?vue&type=template&id=4513571f&scoped=true"
import script from "./SpanLayoutConfig.vue?vue&type=script&lang=js"
export * from "./SpanLayoutConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4513571f",
  null
  
)

export default component.exports